export enum InvoiceActionTypes {
  API_RESPONSE_SUCCESS = '@@invoices/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@invoices/API_RESPONSE_ERROR',

  SET_LOADING_INVOICES = '@@invoices/SET_LOADING_INVOICES',
  RESET = '@@invoices/RESET',
  INVOICES = '@@invoices/INVOICES',

}
